import React, { createContext, useCallback, useContext, useRef } from 'react';

import type { LegalBottomSheetRef } from '@/components/_shared/LegalBottomSheet';
import { LegalBottomSheet } from '@/components/_shared/LegalBottomSheet';

export interface LegalBottomSheetContextType {
  openTerms: () => void;
  openPrivacy: () => void;
}

const LegalBottomSheetContext = createContext<
  LegalBottomSheetContextType | undefined
>(undefined);

export interface LegalBottomSheetProviderProps {
  children: React.ReactNode;
}

export function LegalBottomSheetProvider({
  children,
}: LegalBottomSheetProviderProps) {
  const bottomSheetRef = useRef<LegalBottomSheetRef>(null);

  const openTerms = useCallback(() => {
    bottomSheetRef.current?.open('terms');
  }, []);

  const openPrivacy = useCallback(() => {
    bottomSheetRef.current?.open('privacy');
  }, []);

  const value: LegalBottomSheetContextType = {
    openTerms,
    openPrivacy,
  };

  return (
    <LegalBottomSheetContext.Provider value={value}>
      {children}
      <LegalBottomSheet ref={bottomSheetRef} />
    </LegalBottomSheetContext.Provider>
  );
}

export function useLegalBottomSheet(): LegalBottomSheetContextType {
  const context = useContext(LegalBottomSheetContext);
  if (context === undefined) {
    throw new Error(
      'useLegalBottomSheet must be used within a LegalBottomSheetProvider',
    );
  }
  return context;
}
